import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Table, Divider, Spin, Empty } from "antd";
import "./FichasIndicador.css";
import * as XLSX from "xlsx";
import logo_gobernacion from "../../assets/images/logo_gobernacion.png";
import logo_tangara from "../../assets/images/logo_tangara.png"

const formatArray = (arr) => {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr.join(", ");
  }
  if (arr && typeof arr === "string" && arr.trim() !== "") {
    return arr;
  }
  return "No disponible";
};

const formatInfoGeneral = (infoGeneral) => [
  {
    key: "procedencia",
    label: "Procedencia del indicador",
    value: formatArray(infoGeneral.procedencia),
  },
  {
    key: "grupoTrabajo",
    label: "Grupo de Trabajo",
    value: infoGeneral.grupoTrabajo,
  },
  { key: "email", label: "Correo Electrónico", value: infoGeneral.email },
  {
    key: "fecha",
    label: "Fecha",
    value: new Date(infoGeneral.fecha).toLocaleDateString(),
  },
];

const formatCaracterizacionIndicador = (caracterizacion) => {
  const formattedData = [
    {
      key: "codigo",
      label: "Código del indicador",
      value: caracterizacion.codigoIndicador,
    },
    {
      key: "nombre",
      label: "Nombre del indicador",
      value: caracterizacion.nombreIndicador,
    },
    {
      key: "objetivo",
      label: "Objetivo del indicador",
      value: caracterizacion.objetivoIndicador,
    },
    {
      key: "descripcion",
      label: "Descripción del indicador",
      value: caracterizacion.descripcionIndicador,
    },
    {
      key: "marcoNormativo",
      label: "Marco normativo (si aplica)",
      value: caracterizacion.marcoNormativo,
    },
    {
      key: "formula",
      label: "Fórmula de cálculo del indicador",
      value: caracterizacion.formulaIndicador,
    },
  ];

  if (caracterizacion.variables && caracterizacion.variables.length > 0) {
    const variablesData = caracterizacion.variables
      .map((varItem, index) => [
        {
          key: `variable-${index}`,
          label: "Variable",
          value: varItem.variable,
        },
        { key: `fuente-${index}`, label: "Fuente", value: varItem.fuente },
        { key: `entidad-${index}`, label: "Entidad", value: varItem.entidad },
        {
          key: `link-${index}`,
          label: "Link",
          value: (
            <a
              href={varItem.link}
              target="_blank" // Abre el enlace en una nueva pestaña
              rel="noopener noreferrer" // Mejora de seguridad para prevenir ataques tipo phishing
              style={{
                textDecoration: "none", // Opcional: elimina subrayado
                color: "#007bff", // Opcional: color de enlace
                cursor: "pointer", // Muestra un cursor de mano al pasar sobre el enlace
              }}
            >
              {varItem.link}
            </a>
          ),
        },

      ])
      .flat();
    formattedData.push(...variablesData);
  }

  formattedData.push(
    {
      key: "unidadMedida",
      label: "Unidad de medida del indicador",
      value: formatArray(caracterizacion.unidadMedida),
    },
    {
      key: "urlPaginaAplicacionWeb",
      label: "Página o aplicación web?",
      value: (
        <a
          href={caracterizacion.urlPaginaAplicacionWeb}
          target="_blank" // Abre el enlace en una nueva pestaña
          rel="noopener noreferrer" // Mejora de seguridad para prevenir ataques tipo phishing
          style={{
            textDecoration: "none", // Opcional: elimina subrayado
            color: "#007bff", // Opcional: color de enlace
            cursor: "pointer", // Muestra un cursor de mano al pasar sobre el enlace
          }}
        >
          {caracterizacion.urlPaginaAplicacionWeb}
        </a>
      ),
    },

    {
      key: "desagregacionTematica",
      label: "Desagregación temática del indicador",
      value: formatArray(caracterizacion.desagregacionTematica),
    },
    {
      key: "desagregacionTematicaOtra",
      label: "Otro, ¿cuál?",
      value: caracterizacion.desagregacionTematicaOtra,
    },
    {
      key: "desagregacionGeografica",
      label: "Desagregación geográfica del indicador",
      value: formatArray(caracterizacion.desagregacionGeografica),
    },
    {
      key: "otrosDesagregacionGeografica",
      label: "Otro, ¿cuál?",
      value: caracterizacion.otrosDesagregacionGeografica,
    },
    {
      key: "periodicidadMedicion",
      label: "Periodicidad de medición del indicador",
      value: formatArray(caracterizacion.periodicidadMedicion),
    },
    {
      key: "otrosPeriodicidad",
      label: "Otro, ¿cuál?",
      value: caracterizacion.otrosPeriodicidad,
    },
    {
      key: "periodosDisponibilidad",
      label: "Periodos de disponibilidad del indicador",
      value:
        caracterizacion.fechaDesde && caracterizacion.fechaHasta
          ? `Desde: ${new Date(
            caracterizacion.fechaDesde
          ).toLocaleDateString()} Hasta: ${new Date(
            caracterizacion.fechaHasta
          ).toLocaleDateString()}`
          : "No cuenta con fechas",
    },
    {
      key: "periodicidadDifusion",
      label: "Periodicidad con la que se difunde el indicador",
      value: formatArray(caracterizacion.periodicidadDifusion),
    },
    {
      key: "otrosDifusion",
      label: "Otro, ¿cuál?",
      value: caracterizacion.otrosDifusion,
    },
    {
      key: "otroMedioDifusion",
      label: "Otro medio, ¿cuál?",
      value: caracterizacion.otroMedioDifusion,
    },
    {
      key: "medioVisualizacion",
      label:
        "Medio de visualización en el cual se encuentra disponible los resultados del indicador",
      value: formatArray(caracterizacion.medioVisualizacion),
    },
    {
      key: "otroMedioVisualizacion",
      label: "Otro medio, ¿cuál?",
      value: caracterizacion.otroMedioVisualizacion,
    }
  );

  return formattedData;
};

const formatObservaciones = (observaciones) => [
  {
    key: "observaciones",
    label: "Observaciones",
    value: observaciones.observaciones,
  },
];

const FichasIndicador = forwardRef(
  ({ fichasJson, NameArea, NameTema }, ref) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const nombreIndicador =
      fichasJson?.["Caracterización del Indicador"]?.nombreIndicador ||
      "fichas_indicador";
    useEffect(() => {
      setLoading(true);

      if (fichasJson && Object.keys(fichasJson).length > 0) {
        const formattedData = [];

        // Formatear secciones
        const infoGeneral = formatInfoGeneral(
          fichasJson["Información General"]
        );
        formattedData.push({
          section: "Información General",
          data: infoGeneral,
        });

        const detalleIndicador = formatCaracterizacionIndicador(
          fichasJson["Caracterización del Indicador"]
        );
        formattedData.push({
          section: "Caracterización del Indicador",
          data: detalleIndicador,
        });

        const observaciones = formatObservaciones(fichasJson["Observaciones"]);
        formattedData.push({ section: "Observaciones", data: observaciones });

        setData(formattedData);
      } else {
        setData([]);
      }

      setLoading(false);
    }, [fichasJson]);

    const columns = [
      {
        title: "Atributo",
        dataIndex: "label",
        key: "label",
        width: 250,
      },
      {
        title: "Valor",
        dataIndex: "value",
        key: "value",
        width: 400,
      },
    ];

    // Función para exportar a Excel
    const exportToExcel = () => {
      const timestamp = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      const exportData = data
        .map((section) => {
          return section.data.map((item) => ({
            Módulo: section.section,
            Atributo: item.label,
            Valor: item.value,
          }));
        })
        .flat();

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fichas");

      XLSX.writeFile(workbook, `Ficha_${nombreIndicador}_${timestamp}.xlsx`);
    };

    // Exponer la función exportToExcel a través de la referencia
    useImperativeHandle(ref, () => ({
      exportToExcel,
    }));

    return (
      <div className="container-fluid">

        <div className="Separador">
          <div className="separadorAzul"></div>
          <div className="separadorVerde"></div>
        </div>
        <div className="contenedorEncabezado">
          <div className="contenedorTitulos">
            <p className="titulo">{NameArea}</p>
            <p className="subtitulo">{NameTema}</p>
            <p className="indicador">Indicador: {nombreIndicador}</p>
          </div>
          <div className="contenedorImagenes">
            <img src={logo_gobernacion} alt="Logo 1" className="logo1" />
            <img src={logo_tangara} alt="Logo 2" className="logo2" />
          </div>
        </div>

        {/* Contenedor con scroll y datos */}
        <div
          style={{ maxHeight: "700px", overflowY: "auto", overflowX: "hidden" }}
        >
          {loading ? (
            <Spin size="large" />
          ) : data.length === 0 ? (
            <Empty description="No hay datos disponibles para la ficha técnica." />
          ) : (
            data.map((section, sectionIndex) => (
              <div key={sectionIndex}>
                <h5 style={{ textAlign: "center" }}>
                  MÓDULO DE {section.section.toUpperCase()}
                </h5>
                {/* Contenedor para la tabla con scroll vertical */}
                <div>
                  <Table
                    className="tabla-fichas"
                    columns={columns}
                    dataSource={section.data}
                    pagination={false}
                    rowKey="key"
                    bordered
                    rowClassName={() => "custom-row"}
                  />
                </div>

                <Divider />
              </div>
            ))
          )}
        </div>
      </div>
    );
  }
);

export default FichasIndicador;
